// extracted by mini-css-extract-plugin
export default {"footer":"footer__q6x7H","innogamesLogo":"innogamesLogo__ZZypy","mobilecity":"mobilecity__V9YO7","foe":"foe__Fyyzw","herocity":"herocity__WOiCU","odysseus-prelander":"odysseus-prelander__KxmJ7","odysseus":"odysseus__Rh2gl","onyx":"onyx__UT_av","accordion":"accordion__Plpp8"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"footer\":\"footer__q6x7H\",\"innogamesLogo\":\"innogamesLogo__ZZypy\",\"mobilecity\":\"mobilecity__V9YO7\",\"foe\":\"foe__Fyyzw\",\"herocity\":\"herocity__WOiCU\",\"odysseus-prelander\":\"odysseus-prelander__KxmJ7\",\"odysseus\":\"odysseus__Rh2gl\",\"onyx\":\"onyx__UT_av\",\"accordion\":\"accordion__Plpp8\"}";
        // 1787130556875
        var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  